import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const useDashboardDataForPDF = (selectedSchemeOptions) => {
  const [overviewData, setOverviewData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [otherData, setOtherData] = useState({}); // Add as needed
  const [schemeOverviewDataForPDF,setSchemeOverviewDataForPDF]=useState()
  const [schemeFundPerformanceDataForPDF,setSchemeFundPerformanceDataForPDF]=useState()
  const allSchemeDetails = useSelector(state => state.schemeInfoAgainstInvestor);
  const aumDataAgainstScheme=useSelector(state=>state.aumDataAgainstScheme)
  const [aumDataForSpecificScheme,setAumDataForSpecificScheme]=useState(0)
  const [investorSchemeDetails,setInvestorSchemeDetails]=useState()
  const [schemePortfolioData,setSchemePortfolioData]=useState()
  const [schemeSectorAllocationData,setSchemeSectorAllocationData]=useState()
  const [schemeDocuments,setSchemeDocuments]=useState([])
  const investorInfo = useSelector((state) => state.investorInfo);

// FOR OVERVIEW DATA 
 useEffect(() => {
    if (selectedSchemeOptions && selectedSchemeOptions.length > 0 && allSchemeDetails && allSchemeDetails.length > 0) {
      const schemeName = selectedSchemeOptions[0]?.split("-")[0];
      const schemeClass = selectedSchemeOptions[0]?.split("-")[1];
  
      const innerBlockSchemePerformnceData = allSchemeDetails.filter((overviewData) => (
        overviewData.scheme_name === schemeName && overviewData.scheme_class === schemeClass
      ));
  
     
      setSchemeFundPerformanceDataForPDF(innerBlockSchemePerformnceData[0])
      // You can now use innerBlockSchemeOverviewData for further actions
      console.log("setSchemeFundPerformanceData(innerBlockSchemeOverviewData)",innerBlockSchemePerformnceData);
    }
  }, [selectedSchemeOptions, allSchemeDetails]);

// FOR FUND PERFORMANCE DATA 
  useEffect(() => {
    if (selectedSchemeOptions && selectedSchemeOptions.length > 0 && allSchemeDetails && allSchemeDetails.length > 0) {
      const schemeName = selectedSchemeOptions[0]?.split("-")[0];
      const schemeClass = selectedSchemeOptions[0]?.split("-")[1];
  
      const innerBlockSchemeOverviewData = allSchemeDetails.filter((overviewData) => (
        overviewData.scheme_name === schemeName && overviewData.scheme_class === schemeClass
      ));
      
  
     setSchemeOverviewDataForPDF(innerBlockSchemeOverviewData[0])
    
    if (Array.isArray(aumDataAgainstScheme) && aumDataAgainstScheme.length > 0) {
      const innerBlovkForAumDataForSpecificScheme = aumDataAgainstScheme.filter(
        (aum) => aum.scheme_name === schemeName && aum.scheme_class === schemeClass
      );
    
      // Check if the filtered data exists and has a non-empty `schemes` property
      if (
        innerBlovkForAumDataForSpecificScheme.length > 0 &&
        innerBlovkForAumDataForSpecificScheme[0]?.schemes &&
        innerBlovkForAumDataForSpecificScheme[0]?.schemes.length > 0
      ) {
        setAumDataForSpecificScheme(innerBlovkForAumDataForSpecificScheme[0].schemes[0]);
    
      
      }
    }

    if(investorInfo && Array?.isArray(investorInfo?.schemes) && investorInfo?.schemes?.length>0 ){
      const innerBlockForInvestorScheme=investorInfo?.schemes?.filter(scheme=>
        scheme?.scheme_name===schemeName && scheme?.scheme_class===schemeClass
      )
      setInvestorSchemeDetails(innerBlockForInvestorScheme[0])
         }
    
    }
    
  }, [selectedSchemeOptions,allSchemeDetails,aumDataAgainstScheme,investorInfo]);

// FOR PORTFOLIO AND SECTORAL ALLOCATION DATA 
    useEffect(() => {
      if (selectedSchemeOptions && selectedSchemeOptions.length > 0 && allSchemeDetails && allSchemeDetails.length > 0) {
        const schemeName = selectedSchemeOptions[0]?.split("-")[0];
        const schemeClass = selectedSchemeOptions[0]?.split("-")[1];
    
        const innerBlockSchemePortfolioAndSectoralAllocation = allSchemeDetails.filter((overviewData) => (
          overviewData.scheme_name === schemeName && overviewData.scheme_class === schemeClass
        ));
    
        

        const holdings = innerBlockSchemePortfolioAndSectoralAllocation[0]?.Portfolio
        ?.filter(item => item?.holding_name && item?.holding !== undefined && item?.holding !== null && item?.holding !== "")
        .map((item, index) => ({
          name: item.holding_name,
          percentage: item.holding,
          as_on_date:item.as_on_date,
        }));
      
        setSchemePortfolioData(holdings)

        

        const data = [
            ["Sectoral Allocation", "percentage"], // Header row
            ...(innerBlockSchemePortfolioAndSectoralAllocation[0]?.sectoral_wise_allocation?.length
              ? innerBlockSchemePortfolioAndSectoralAllocation[0].sectoral_wise_allocation
                  // .sort((a, b) => b.holding - a.holding) // Sort by holdings in descending order
                  // .slice(0, 10) // Get the top 10 holdings
                  .map((item) => [item.sector_name, parseFloat((item.holding * 100).toFixed(2))]) // Map and round the holding values
              : []) // Empty array if no data is available
          ];

          setSchemeSectorAllocationData(data)
        // You can now use innerBlockSchemeOverviewData for further actions
     
      }
    }, [selectedSchemeOptions, allSchemeDetails]);
    
// FOR SCHEME DOCUMENT DATA 
  useEffect(() => {
    if (
      selectedSchemeOptions &&
      selectedSchemeOptions.length > 0 &&
      investorInfo &&
      investorInfo?.schemes &&
      investorInfo?.schemes.length > 0
    ) {
      const schemeName = selectedSchemeOptions[0]?.split("-")[0];
      const schemeClass = selectedSchemeOptions[0]?.split("-")[1];
  
      // Filter schemes matching schemeName and schemeClass
      const innerBlockSchemeDetails = investorInfo?.schemes
        ?.filter(
          (scheme) =>
            scheme.scheme_name === schemeName &&
            scheme.scheme_class === schemeClass
        )
        ?.flatMap((scheme) => scheme?.documents || []); // Flatten all documents into a single array
  
    
      // Map documents into the desired structure
      const innerBlockDocuments =
        innerBlockSchemeDetails?.map((document) => ({
          scheme_name:schemeName,
          scheme_class: schemeClass,
          name: document.name,
          url: document.url,
          file_name:document.file_name,
          type: document.type?.split("/")[1], // Ensure type exists before splitting
        })) || [];
  

  
      // Update state based on documents
      setSchemeDocuments(innerBlockDocuments.length > 0 ? innerBlockDocuments : []);
  
    }
  }, [selectedSchemeOptions, investorInfo]);
  
   

  return {schemeFundPerformanceDataForPDF,aumDataForSpecificScheme,investorSchemeDetails,schemeOverviewDataForPDF ,schemePortfolioData,schemeSectorAllocationData,schemeDocuments};
};

export default useDashboardDataForPDF;
